module.exports = __webpack_public_path__ + "img/quizz-step-5-2.2c94d7d2.jpg";